// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/ContractSigned/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_Content_TreatmentPlans_Steps_Content_Contracts_Content_Payor_Content_ContractSigned_Content($id: numeric!) {
  vaxiom_tx_contracts_by_pk(id: $id) {
    id
    signed_date
  }
}

`